import { defineStore } from 'pinia';

export const useInterfaceStore = defineStore('interface', {
  state: () => ({
    cursorColor: 'default',
    cursorHover: false,
  }),
  actions: {
    setCursorColor(color) {
      this.cursorColor = color;
    },
    setCursorHover(hover) {
      this.cursorHover = hover;
    }
  }
});
